import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from "react-router-dom";
import { useGetRoleByIdQuery } from "../../services/accessRole";
import usePermission from "../../hooks/userAccess";

const RoleDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isView } = usePermission({
    label: 'Manage Sub-Admin',
    page_permission: 'isView',
  })

  const { data, isLoading } = useGetRoleByIdQuery(
    { id: id as string },
    { skip: !id }
  );

  const role = data?.data as any;
  const rows = Array.isArray(role?.permission)
    ? role.permission.map((perm: any, idx: number) => ({
      id: Number(perm?.sideBarId) || idx + 1,
      name: perm?.label || "-",
      view: !!perm?.isView,
      add: !!perm?.isAdd,
      edit: !!perm?.isEdit,
      delete: !!perm?.isDelete,
    }))
    : [];

  return (
    <>
      <div className="main_title">
        <h1>Role Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {" "} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {" "} - <button onClick={() => navigate(-1)}>Manage Roles</button>
          {" "} - Role Detail
        </p>
      </div>

      {isView && <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>{role?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>{role?.createdAt ? new Date(role.createdAt).toLocaleDateString() : "-"}</p>
          </div>
        </div>

        <TableContainer className="table_container mt_20">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Module Name</TableCell>
                <TableCell align="center">Add/Edit</TableCell>
                <TableCell align="center">Delete</TableCell>
                <TableCell align="center">View</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow hover>
                  <TableCell colSpan={5}>Loading...</TableCell>
                </TableRow>
              ) : rows.length ? (
                rows.map((row: any) => (
                  <TableRow hover key={row?._id}>
                    <TableCell>{row?.name || '-'}</TableCell>
                    <TableCell align="center">
                      {(row?.add || row?.edit) ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                    </TableCell>
                    <TableCell align="center">
                      {row?.delete ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                    </TableCell>
                    <TableCell align="center">
                      {row?.view ? <DoneIcon className="c_success" /> : <CloseIcon className="c_danger" />}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow hover>
                  <TableCell colSpan={5}>No permissions found.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>}
    </>
  );
};

export default RoleDetail;
